import React from "react";
import PropTypes from "prop-types";
import { themr } from "react-css-themr";
import classnames from "classnames";

import styles from "./CardNumber.m.scss";

function CardNumber(props) {
  const { theme, pan } = props;

  return (
    <div className={classnames(theme.wrapper)}>
      {pan
        ? pan.match(/.{1,4}/g).map((part, index) => (
            <span className={classnames(theme.part)} key={index}>
              {part}
            </span>
          ))
        : "-"}
    </div>
  );
}

CardNumber.displayName = "CardNumber";

CardNumber.propTypes = {
  theme: PropTypes.object,
  pan: PropTypes.string,
};

CardNumber.defaultProps = {};
export default themr("@lifepay/CardNumber", styles)(CardNumber);



// WEBPACK FOOTER //
// ./src/components/utils/CardNumber/CardNumber.js